// ---- PAYMENT METHODS IN CART ----

(function () {
  // ---- Stellschrauben ----
  const CH_IMG = 'https://cdn.shopify.com/s/files/1/0918/2743/7948/files/Payment_Methods_CH_Cart_5c258cc0-e063-464e-b82c-6cf378bc16cc_1024x1024.png?v=1783091622';
  const DE_IMG = 'https://cdn.shopify.com/s/files/1/0918/2743/7948/files/Payment_Methods_DE_Cart.png?v=1783091552';

  const KEEP_CH_COUNTRIES = ['CH', 'LI']; // diese Länder behalten das CH-Bild

  function currentCountry() {
    // Shopify setzt den ISO-Code des aktiven Markt-/Länderkontexts
    return (window.Shopify && Shopify.country ? Shopify.country : '').toUpperCase();
  }

  function applySwap() {
    const img = document.querySelector('.ast-cart__trust img');
    if (!img) return;

    const country = currentCountry();
    if (!country) return; // Land nicht erkennbar -> lieber nichts anfassen (CH-Default bleibt)

    const target = KEEP_CH_COUNTRIES.includes(country) ? CH_IMG : DE_IMG;
    if (img.getAttribute('src') !== target) {
      img.setAttribute('src', target);
    }
  }

  applySwap();

  // Assortion-Cart rendert bei Updates neu -> Bild nachziehen
  const observer = new MutationObserver(applySwap);
  observer.observe(document.body, { childList: true, subtree: true });
})();